import React, { useState } from "react";
import axios from 'axios';
import { API_PROVEEDORES_URL } from '../../../constants';

//Estilos
import "../../Requisiciones/css/Requisiciones.css"
import "../css/CuentasBancarias.css"
import { PencilSquare } from 'react-bootstrap-icons';
import { toast } from 'react-toastify';

//Elementos bootstrap
import { Form, Col, Container, Modal } from "react-bootstrap";

//Componentes
import NumberFormat from 'react-number-format';

function ModalEditarCuenta(props) {
    const [status, setStatus] = useState(false);
    const [banco, setBanco] = useState(props.children.banco);
    const [comentario, setComentario] = useState(props.children.comentario)
    const [cuenta, setCuenta] = useState(props.children.cuenta);
    const [cuentaClabe, setCuentaClabe] = useState(props.children.cuentaClabe);
    const [referencia, setReferencia] = useState(props.children.referencia);

    function handleBancoChange(e) {
        setBanco(e.target.value);
    }
    function handleComentarioChange(e) {
        setComentario(e.target.value);
    }
    function handleCuentaChange(e) {
        setCuenta(e.target.value);
    }
    function handleCuentaClabeChange(e) {
        setCuentaClabe(e.target.value);
    }
    function handleReferenciaChange(e) {
        setReferencia(e.target.value);
    }

    function validateCuenta() {
        if (banco.trim() === '') {
            toast.error('El campo "Banco" es obligatorio, por favor ingrese la información correspondiente antes de actualizar', {
                position: "top-center",
                autoClose: 4500,
            });
            return;
        }

        if (cuenta.trim() === '' && cuentaClabe.trim() === '') {
            toast.error('Debe completar el campo "Cuenta" o "Cuenta Clabe"', {
                position: "top-center",
                autoClose: 4500,
            });
            return;
        }

        editCuenta();
    }

    function editCuenta() {
        setStatus(true);
        axios.post(API_PROVEEDORES_URL + 'updateCuenta',
            {
                idCuenta: props.children.idProveedorCuenta,
                idProveedor: props.children.idProveedor,
                banco: banco,
                cuenta: cuenta,
                cuentaClabe: cuentaClabe,
                comentario: comentario,
                referencia: referencia
            }
        ).then((res) => {
            if (res.data.result.success) {
                setStatus(false);
                toast.success(res.data.result.message,{
                    position:"top-center",
                    autoClose: 4500, 
                });
                props.onHide();//Cierra el modal, llamando a la función padre para cerrarlo
                props.onUpdate();//Actualiza el listado, llamando a la función padre para actualizarlo                       
            } else {
                toast.error(res.data.result.message,{
                    position:"top-center",
                    autoClose: 4500, 
                });
                toast.error(res.data.result.suggestion,{
                    position:"top-center",
                    autoClose: 4500, 
                });
            
                setStatus(false);
            }
        }).catch((error) => {
            toast.error("No se ha podido actualizar la cuenta bancaria",{
                position:"top-center",
                autoClose: 4500, 
            });
            setStatus(false);
        });
    }

    return (
        <section className="text-center">
            <Modal
                show={props.show}
                //onHide={props.onHide}
                size="md"
                id="modalEditarCuenta"
                aria-labelledby="example-modal-sizes-title-vcenter"
                centered
            >
                <Modal.Header className="modal-header-editar-cuenta" closeButton onHide={props.onHide}>
                    <h5 className="legend-editar-cuenta"><PencilSquare size={22} color="#5B4B51" /> Editar cuenta bancaria</h5>
                </Modal.Header>
                <Container>
                    <Modal.Body className="modal-body-cuenta">
                        <Form>
                            <fieldset >
                                <legend className="legend-editar-cuenta">Cuenta bancaria</legend>
                                <Form.Row >
                                    <Form.Group as={Col}>
                                        <Form.Label>Banco</Form.Label>
                                        <Form.Control type="text" required id="banco"
                                            className="form-control form-control-sm"
                                            placeholder="Ingrese banco"
                                            defaultValue={banco}
                                            onChange={handleBancoChange}>
                                        </Form.Control>
                                    </Form.Group>
                                    <Form.Group as={Col}>
                                        <Form.Label>Comentario</Form.Label>
                                        <Form.Control type="text" required id="comentario"
                                            className="form-control form-control-sm"
                                            placeholder="Ingrese notas adicionales"
                                            defaultValue={comentario}
                                            onChange={handleComentarioChange}>
                                        </Form.Control>
                                    </Form.Group>
                                </Form.Row>
                                <Form.Row >
                                    <Form.Group as={Col}>
                                        <Form.Label>Cuenta</Form.Label>
                                        <NumberFormat
                                            id="cuenta"
                                            format="#### #### #### #### #### ####"
                                            mask="_"
                                            className="form-control form-control-sm"
                                            required
                                            defaultValue={cuenta}
                                            placeholder="Ingrese número de cuenta"
                                            onChange={handleCuentaChange}
                                        />
                                        <Form.Text muted>Hasta 24 dígitos </Form.Text>
                                    </Form.Group>
                                    <Form.Group as={Col}>
                                        <Form.Label>Cuenta CLABE</Form.Label>
                                        <NumberFormat
                                            id="cuentaClabe"
                                            format="#### #### #### #### ##"
                                            mask="_"
                                            className="form-control form-control-sm"
                                            required
                                            defaultValue={cuentaClabe}
                                            placeholder="Ingrese cuenta clabe"
                                            onChange={handleCuentaClabeChange}
                                        />
                                        <Form.Text muted>18 dígitos </Form.Text>
                                    </Form.Group>
                                </Form.Row>
                                <Form.Row >
                                    <Form.Group as={Col}>
                                        <Form.Label>Referencia</Form.Label>
                                        <Form.Control
                                            type="text" id="referencia"
                                            placeholder="Ingrese referencia"
                                            className="form-control form-control-sm"
                                            defaultValue={referencia}
                                            onChange={handleReferenciaChange}>
                                        </Form.Control>
                                    </Form.Group>
                                </Form.Row>
                            </fieldset>
                        </Form>
                    </Modal.Body>
                    <Modal.Footer className="justify-content-center">
                        <button
                            className="m-1 button-default-confirmar"
                            data-toggle="tooltip"
                            data-placement="bottom"
                            title="Guardar Cuenta"
                            disabled={status}
                            onClick={validateCuenta}
                        >{status ?
                            <span>Guardando...</span>
                            : <span>Confirmar</span>}
                        </button>
                        <button
                            className="m-1 button-default-subir-archivo"
                            data-toggle="tooltip"
                            data-placement="bottom"
                            title="Cancelar"
                            onClick={props.onHide}
                        ><span>Cancelar</span>
                        </button>
                    </Modal.Footer>
                </Container>
            </Modal>
        </section>
    );
}
export default ModalEditarCuenta;